import { ValidationResult } from "./validation-result";

export interface ManufacturedFor {
  id: number;
  description: string | null;
  activeStatus: string | null;
  labeler: string | null;
}

export class ManufacturedFor {
  id: number;
  description: string | null;
  activeStatus: string | null;
  labeler: string | null;

  constructor() {
    this.id = 0;
    this.description = '';
    this.activeStatus = '';
    this.labeler = '';
  }

  validateRecord(): ValidationResult {
    const vr = new ValidationResult();

    if (!this.description || this.description.trim().length === 0) {
      vr.focus_field = 'description';
      vr.error = 'Error: description is required';
      return vr;
    }

    if (!this.labeler || this.labeler.trim().length === 0) {
      vr.focus_field = 'labeler';
      vr.error = 'Error: labeler is required';
      return vr;
    }

    return vr;
  }
}

export interface ManufacturedBy {
  id: number;
  description: string | null;
  activeStatus: string | null;
}

export class ManufacturedBy {
  id: number;
  description: string | null;
  activeStatus: string | null;

  constructor() {
    this.id = 0;
    this.description = '';
    this.activeStatus = '';
  }

  validateRecord(): ValidationResult {
    const vr = new ValidationResult();

    if (!this.description || this.description.trim().length === 0) {
      vr.focus_field = 'description';
      vr.error = 'Error: description is required';
      return vr;
    }

    return vr;
  }
}
